/* eslint-disable react/no-array-index-key */
import React from 'react';
import StarSVG from 'assets/images/star.svg';
import { STATUS } from 'constants/constants';
import InvestmentApplicationNavigationButton from 'components/InvestmentApplicationNavigationButton';
import { getApplicationStatuses, canContinueConsultation } from './utils';

export const applicationsAdapter = ({
    data, t, getFormattedDate,
}) => {
    const adaptedTableData = data?.applications?.map(
        ({
            applicationIds,
            advisoryNumber,
            productNames,
            modelPortfolioNames,
            createdDate,
            advisor,
            containerId,
            statuses,
        }) => ({
            applicationIds,
            advisoryNumber,
            productNames,
            modelPortfolioNames,
            createdDate,
            advisor,
            statuses,
            containerId,
            canContinue: canContinueConsultation(statuses),
            applicationStatuses: getApplicationStatuses(statuses, t),
        }),
    );

    const tableData = adaptedTableData && adaptedTableData.map(
        ({
            applicationIds,
            advisoryNumber,
            productNames,
            modelPortfolioNames,
            createdDate,
            advisor,
            statuses,
            applicationStatuses,
            containerId,
            canContinue,
        }) => ({
            applicationId: () => (
                <>{applicationIds.map((id, index) => <p key={`${id}-${index}`}>{id}</p>)}</>
            ),
            advisory: advisoryNumber ? () => (
                <p className="advisory-cell nowrap">
                    <img className="star-icon" src={StarSVG} alt={t('starImg')} />
                    [
                    {advisoryNumber}
                    ]
                </p>
            ) : '',
            products: () => (
                <>{productNames.map((product, index) => <p className="nowrap" key={`${product}-${index}`}>{product}</p>)}</>
            ),
            strategy: () => (
                <>{modelPortfolioNames.map((modelPortfolioName, index) => <p className="nowrap" key={`${modelPortfolioName}-${index}`}>{modelPortfolioName}</p>)}</>
            ),
            createdDate: getFormattedDate(createdDate),
            advisorName: () => (
                <>{advisor.map((name, index) => <p className="nowrap" key={`${name}-${index}`}>{name}</p>)}</>
            ),
            status: applicationStatuses ? () => (
                <>
                    {applicationStatuses.map((status, index) => <p className="nowrap" key={`${status}-${index}`}>{status}</p>)}
                </>
            ) : <></>,
            applicationDetails: canContinue ? () => InvestmentApplicationNavigationButton(
                {
                    applicationId: applicationIds?.[0],
                    inProgress: statuses?.includes(STATUS.in_progress),
                    destinationId: containerId === '00000000-0000-0000-0000-000000000000' ? applicationIds?.[0] : containerId,
                    destination: containerId === '00000000-0000-0000-0000-000000000000' ? 'application' : 'container',
                },
            ) : <></>,
        }),
    );

    return {
        totalPages: data?.total,
        applications: tableData,
    };
};
